var render = function (_h,_vm) {var _c=_vm._c;return _c('span',[_vm._v(" "+_vm._s(_vm.$options.methods.outputFormat(_vm.props))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }